import * as React from "react";
const Help = props => <symbol viewBox="0 0 24 24" {...props}>
    <g>
      <path d="M12 2.25A9.75 9.75 0 1021.75 12 9.761 9.761 0 0012 2.25zm0 18A8.25 8.25 0 1120.25 12 8.26 8.26 0 0112 20.25z" />
      <path d="M12 7.083a2.753 2.753 0 00-2.75 2.75.75.75 0 101.5 0 1.25 1.25 0 012.5 0c0 .374-.166.613-.658.945A2.595 2.595 0 0011.25 13v.25a.75.75 0 101.5 0V13c0-.39.171-.636.68-.978a2.555 2.555 0 001.32-2.188A2.753 2.753 0 0012 7.084zm-.004 8.042a1.127 1.127 0 10.004 0z" />
    </g>
  </symbol>;
export default Help;